import { JsonFilterPipe } from '../../filters/json-filter.pipe';
import { TranslatePipe } from '../../filters/translate.pipe';
import { LoaderOverlayComponent } from '../../components/loader-overlay/loader-overlay.component';
import { InputAutocompleteComponent } from '../../components/input-autocomplete/input-autocomplete.component';
import { Component, OnInit, OnDestroy, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import RestService from '../../services/core-rest.service';
import SymptomCheckService from '../../services/symptom-check.service';
import AngularHelperService from '../../services/angular-helper.service';
import AngularRoutingHelperService from '../../services/angular-routing-helper.service';
import { Input, Output, EventEmitter } from '@angular/core';
import {BodyModelComponent} from "../body-model/body-model.component";

@Component({
	standalone: true,
	selector: 'symptom-check-symptoms',
	templateUrl: './symptom-check-symptoms.component.html',
	imports: [CommonModule, JsonFilterPipe, TranslatePipe, LoaderOverlayComponent, InputAutocompleteComponent, FormsModule, BodyModelComponent]
})
export class SymptomCheckSymptomsComponent implements OnInit, OnDestroy {
	private restService: RestService = inject(RestService);
	private symptomCheckService: SymptomCheckService = inject(SymptomCheckService);
	private angularHelperService: AngularHelperService = inject(AngularHelperService);
	private angularRoutingHelperService: AngularRoutingHelperService = inject(AngularRoutingHelperService);
	
	@Input() interview: any;
	@Output() interviewChange: EventEmitter<any> = new EventEmitter<any>();
	@Input() bodyPartSelected: any;
	@Input() selectedSymptoms: any = [];

	vm: any = undefined;
	watcher: any = undefined;
	
	constructor() {
		this.vm = this;
	}
	
	ngOnInit() {
		// TODO ANGULAR_2: is this actually needed anymore?
		var currentSymptom = undefined;
		this.watcher = this.angularHelperService.createInterval(() => {
			var newSymptom = this.vm.symptom;
			if (!this.angularHelperService.isEqual(currentSymptom, newSymptom)) {
				if (newSymptom) {					
					currentSymptom = Object.assign({}, newSymptom);
					this.handleSymptomChange(newSymptom);
				} else {
					currentSymptom = undefined;
				}
			}
		}, 300);
		
		this.vm.params = this.angularRoutingHelperService.getQueryParams() || {};
		if (this.vm.params['type'] === 'pre-visit') {
			this.vm.preVisit = true;
		}
		
		this.vm.handleSymptomSearch = this.handleSymptomSearch;
		this.vm.handleSymptomRemove = this.handleSymptomRemove;
		this.vm.onSelectedSymptomsChange = this.onSelectedSymptomsChange;
		this.vm.handleBack = this.symptomCheckService.prevStep;
		this.vm.handleSubmit = this.handleSubmit;
		
		this.vm.isInitialized = true;
	}
	
	ngOnDestroy() {
		if (this.watcher) {
			this.angularHelperService.cancelInterval(this.watcher);
		}
	}
	
	selectSymptom = (newItem: any): void => {
		this.handleSymptomChange(newItem.selectedItem);
	}
	
	handleSymptomChange(newItem) {
		var interview: any = this.symptomCheckService.getInterviewResetTo(4);
		var isInEvidence: any = !!this.vm.interview.evidence.filter(function(evidence) { return evidence.id === newItem?.id; }).length;
		
		if (!isInEvidence) {
			interview.evidence.push({
				choice_id: 'present',
				id: newItem.id,
				source: 'initial',
				common_name: newItem.common_name || newItem.name,
				addedAtStep: 4,
			});
		}
		
		this.vm.symptom = undefined;
		this.vm.interview = interview;
		this.interviewChange.emit(this.vm.interview);
	}
	
	handleSymptomRemove(id) {
		var interview: any = this.symptomCheckService.getInterviewResetTo(4);
		interview.evidence = interview.evidence.filter(function(evidence) { return evidence.id !== id; });
		this.vm.interview = interview;
		this.interviewChange.emit(this.vm.interview);
		this.removeSymptom(id);
	}
	
	handleSymptomSearch = (searchParams: any): any => {
		var namePart = searchParams.namePart;
		
		var deferred: any = this.angularHelperService.getDeferredPromise();
		
		var searchParams: any = { phrase: namePart };
		if (this.vm.interview.sex) {
			searchParams.sex = this.vm.interview.sex;
		}
		if (this.vm.interview.age) {
			searchParams.ageValue = this.vm.interview.age;
		}
		if (this.vm.preVisit) {
			searchParams.type = 'pre-visit';
		}
		this.restService.getSymptomSearch(searchParams)
			.then((res) => {
				var items: any = res.map(function(item) { return { id: item.id, name: item.common_name || item.name, alias: item.alias }; });
				deferred.resolve(items);
			})
			.catch((err) => {
				console.error(err);
				deferred.reject(err);
			});
		
		return deferred.promise;
	}
	
	handleSubmit() {
		var hasExtendedSymptoms: any = !!this.vm.interview.evidence.filter(function(evidence) { return evidence.id.startsWith('md_'); }).length;
		if (!hasExtendedSymptoms) {
			this.symptomCheckService.nextStep();
		} else {
			this.handleNoInterviewSubmit();
		}
	}
	
	handleNoInterviewSubmit() {
		if (this.vm.isProcessing) return;
		this.vm.isProcessing = true;
		
		if (!this.vm.interview.sessionId) {
			this.vm.interview.sessionId = 'create';
			this.vm.interview.stepId = 0;
		}
		
		if (this.vm.preVisit) {
			this.vm.interview.preVisit = true;
		}
		
		this.restService.saveDiagnosis(this.vm.interview)
			.then((res) => {
				if (!res.interview) return;
				var interview: any = this.angularHelperService.copy(this.vm.interview);
				interview.sessionId = res.interview.sessionId;
				interview.localId = res.interview.localId;
				interview.sex = res.interview.sex;
				interview.age = res.interview.age;
				interview.diagnosis = res;

				this.vm.interview = interview;
				this.interviewChange.emit(this.vm.interview);

				if (interview.diagnosis.should_stop) {
					this.vm.interview = interview;
					this.angularHelperService.createTimer(() => { this.symptomCheckService.nextStep(2); });
					return;
				}

				this.angularHelperService.createTimer(() => {
					this.symptomCheckService.nextStep();
				});
			})
			.catch(console.error);
	}

	removeSymptom(symptomId): void {
		const index = this.vm.selectedSymptoms.findIndex(s => s.id === symptomId);
		if (index !== -1) {
			this.vm.selectedSymptoms.splice(index, 1);
		}
	}

	onSelectedSymptomsChange(selectedSymptoms: { id: number; name: string, bodyPart: string }[]): void {
		var currentSymptom = undefined;
		this.vm.selectedSymptoms = selectedSymptoms;
		this.vm.selectedSymptoms.forEach(newItem => {
			var bodyPartSymptom = newItem;
			if (!this.angularHelperService.isEqual(currentSymptom, bodyPartSymptom)) {
				if (bodyPartSymptom) {
					currentSymptom = Object.assign({}, bodyPartSymptom);
					this.handleSymptomChange(bodyPartSymptom);
				} else {
					currentSymptom = undefined;
				}
			}
		});
	}

	isBodyPartSelected(bodyPart: string): boolean {
		var selectedBodyParts = this.vm.selectedSymptoms.map(symptom => symptom.bodyPart)
		return selectedBodyParts.includes(bodyPart);
	}
	
}